/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CardNumber,
  CardNumberOptional,
  CardNumberMetaI,
  CardNumberTrackedI,
} from "./card-number";
import { CardNumberTracked, CardNumberMeta } from "./card-number";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Purchasable,
  PurchasableOptional,
  PurchasableMetaI,
  PurchasableTrackedI,
} from "./purchasable";
import { PurchasableTracked, PurchasableMeta } from "./purchasable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";

/**
 *
 * @export
 * @interface CardBase
 */
export interface CardBaseOptional extends CardNumberOptional {
  /**
   *
   * @type {number}
   * @memberof CardBase
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof CardBase
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof CardBase
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof CardBase
   */
  voidCloseId?: number;
  /**
   *
   * @type {string}
   * @memberof CardBase
   */
  cardNum?: string;
  /**
   *
   * @type {string}
   * @memberof CardBase
   */
  issueDate?: Date;
  /**
   *
   * @type {string}
   * @memberof CardBase
   */
  temp?: string;
  /**
   *
   * @type {boolean}
   * @memberof CardBase
   */
  active?: boolean;
}

export interface CardBase extends CardBaseOptional, CardNumber, Purchasable {
  /**
   *
   * @type {number}
   * @memberof CardBase
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof CardBase
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof CardBase
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof CardBase
   */
  voidCloseId?: number;
  /**
   *
   * @type {string}
   * @memberof CardBase
   */
  cardNum: string;
  /**
   *
   * @type {string}
   * @memberof CardBase
   */
  issueDate?: Date;
  /**
   *
   * @type {string}
   * @memberof CardBase
   */
  temp?: string;
  /**
   *
   * @type {boolean}
   * @memberof CardBase
   */
  active?: boolean;
}

export interface CardBaseTrackedI extends CardNumberOptional {
  /**
   *
   * @type {number}
   * @memberof CardBase
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof CardBase
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CardBase
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CardBase
   */
  voidCloseId?: number;
  voidCloseIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CardBase
   */
  cardNum?: string;
  cardNumIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CardBase
   */
  issueDate?: Date;
  issueDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CardBase
   */
  temp?: string;
  tempIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CardBase
   */
  active?: boolean;
  activeIsSet: boolean;
}

transformDatesMap.set("CardBase", function (model: CardBase) {
  if (typeof model.purchaseDate == "string")
    model.purchaseDate = new Date(model.purchaseDate);
  if (typeof model.issueDate == "string")
    model.issueDate = new Date(model.issueDate);
});

export type CardBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  voidCloseId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  cardNum: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  issueDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  temp: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var CardBaseMeta: CardBaseMetaI = {} as CardBaseMetaI;
CardBaseMeta = typeMeta("CardBase", {
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  voidCloseId: propertyMeta(
    "voidCloseId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  cardNum: propertyMeta("cardNum", false, true, false, MetaTypesBase.string),
  issueDate: propertyMeta("issueDate", false, false, false, MetaTypesBase.Date),
  temp: propertyMeta("temp", false, false, false, MetaTypesBase.string),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
});

const metaI = CardBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PurchasableMeta]);
  metaI.price.inheritedFrom = PurchasableMeta.price;
  metaI.purchasableState.inheritedFrom = PurchasableMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom = PurchasableMeta.purchaseDate;
  metaI.voidCloseId.inheritedFrom = PurchasableMeta.voidCloseId;
  metaI.interfaces = metaI.interfaces.concat([CardNumberMeta]);
  metaI.cardNum.inheritedFrom = CardNumberMeta.cardNum;
});

export class CardBaseTracked
  extends CardNumberTracked
  implements CardBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  voidCloseId__I?: number = undefined;
  voidCloseIdIsSet: boolean = false;
  set voidCloseId(v: undefined | number) {
    if (v !== undefined) {
      this.voidCloseId__I = v;
      this.voidCloseIdIsSet = true;
    } else {
      this.voidCloseId__I = v || undefined;
      this.voidCloseIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get voidCloseId() {
    return this.voidCloseId__I;
  }
  cardNum__I?: string = undefined;
  cardNumIsSet: boolean = false;
  set cardNum(v: undefined | string) {
    if (v !== undefined) {
      this.cardNum__I = v;
      this.cardNumIsSet = true;
    } else {
      this.cardNum__I = v || undefined;
      this.cardNumIsSet = true;
    }
    this.changeTracker = true;
  }
  get cardNum() {
    return this.cardNum__I;
  }
  issueDate__I?: Date = undefined;
  issueDateIsSet: boolean = false;
  set issueDate(v: undefined | Date) {
    if (v !== undefined) {
      this.issueDate__I = v;
      this.issueDateIsSet = true;
    } else {
      this.issueDate__I = v || undefined;
      this.issueDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get issueDate() {
    return this.issueDate__I;
  }
  temp__I?: string = undefined;
  tempIsSet: boolean = false;
  set temp(v: undefined | string) {
    if (v !== undefined) {
      this.temp__I = v;
      this.tempIsSet = true;
    } else {
      this.temp__I = v || undefined;
      this.tempIsSet = false;
    }
    this.changeTracker = true;
  }
  get temp() {
    return this.temp__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  constructor(config?: CardBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CardBaseOptional,
    options?: AssignOptions,
  ): CardBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.voidCloseId &&
      this.voidCloseIdApplyFilter(optionsRequired.filter)
    ) {
      this.voidCloseId = config.voidCloseId;
      if (optionsRequired.unassign) this.voidCloseIdIsSet = false;
      else this.voidCloseIdIsSet = true;
    }
    if (config.cardNum && this.cardNumApplyFilter(optionsRequired.filter)) {
      this.cardNum = config.cardNum;
      if (optionsRequired.unassign) this.cardNumIsSet = false;
      else this.cardNumIsSet = true;
    }
    if (config.issueDate && this.issueDateApplyFilter(optionsRequired.filter)) {
      this.issueDate = config.issueDate;
      if (optionsRequired.unassign) this.issueDateIsSet = false;
      else this.issueDateIsSet = true;
    }
    if (config.temp && this.tempApplyFilter(optionsRequired.filter)) {
      this.temp = config.temp;
      if (optionsRequired.unassign) this.tempIsSet = false;
      else this.tempIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CardBaseTrackedI {
    const cloned = {} as CardBaseTrackedI;
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.voidCloseIdIsSetDeep() &&
      this.voidCloseIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.voidCloseIdIsSet = true;
      cloned.voidCloseId = this.voidCloseId;
    } else {
      //cloned.voidCloseIdIsSet = false
    }
    if (
      this.cardNumIsSetDeep() &&
      this.cardNumApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cardNumIsSet = true;
      cloned.cardNum = this.cardNum;
    } else {
      //cloned.cardNumIsSet = false
    }
    if (
      this.issueDateIsSetDeep() &&
      this.issueDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.issueDateIsSet = true;
      cloned.issueDate = this.issueDate;
    } else {
      //cloned.issueDateIsSet = false
    }
    if (
      this.tempIsSetDeep() &&
      this.tempApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIsSet = true;
      cloned.temp = this.temp;
    } else {
      //cloned.tempIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CardBaseTrackedI {
    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.voidCloseIdApplyFilter(filter)) this.voidCloseIdIsSet = false;

    if (!this.cardNumApplyFilter(filter)) this.cardNumIsSet = false;

    if (!this.issueDateApplyFilter(filter)) this.issueDateIsSet = false;

    if (!this.tempApplyFilter(filter)) this.tempIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    return this;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CardBaseMeta.price, CardBaseMeta, this.price, this);
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CardBaseMeta.purchasableState,
      CardBaseMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CardBaseMeta.purchaseDate,
      CardBaseMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  voidCloseIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CardBaseMeta.voidCloseId,
      CardBaseMeta,
      this.voidCloseId,
      this,
    );
  }
  voidCloseIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.voidCloseIdIsSet && this.voidCloseIdApplyFilter(filter))
      return true;

    return false;
  }
  cardNumApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CardBaseMeta.cardNum, CardBaseMeta, this.cardNum, this);
  }
  cardNumIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cardNumIsSet && this.cardNumApplyFilter(filter)) return true;

    return false;
  }
  issueDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CardBaseMeta.issueDate, CardBaseMeta, this.issueDate, this);
  }
  issueDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.issueDateIsSet && this.issueDateApplyFilter(filter)) return true;

    return false;
  }
  tempApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CardBaseMeta.temp, CardBaseMeta, this.temp, this);
  }
  tempIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIsSet && this.tempApplyFilter(filter)) return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CardBaseMeta.active, CardBaseMeta, this.active, this);
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.voidCloseIdIsSetDeep(filter)) return true;
    if (this.cardNumIsSetDeep(filter)) return true;
    if (this.issueDateIsSetDeep(filter)) return true;
    if (this.tempIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
